import React, { useEffect, useState } from "react";
import "./News.css";
import { Link } from "react-router-dom";
import Loader from "../addons/Loader";

function News() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetch(
      "https://fedev.fues.hr/backend/wp-json/wp/v2/posts?_embed&categories=3"
    )
      .then((response) => response.json())
      .then((data) => {
        setPosts(data);
        setTimeout(() => {
          setLoading(false);
        }, 1500);
      });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

   if (loading)
    return (
      <div className="container loading">
        <Loader />
      </div>
    );

  return (
    <>
      <section className="news">
        <div className="container">
          <div className="row g-4">
            {posts.map((post) => {
              const featuredImage =
                post?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes
                  ?.full?.source_url;

              const date = formatDate(post.date);

              return (
                <div key={post.id} className="col-12">
                  <article className="news-container">
                    <div className="row g-4">
                      <div className="col-md-4">
                        <Link to={`/novosti/${post.slug}`}>
                        <img className="newsImage" src={featuredImage} alt="" />
                        </Link>
                      </div>
                      <div className="col-md-8">
                        <Link to={`/novosti/${post.slug}`}>
                        <h2 className="newsTitle">{post.title.rendered}</h2>
                        </Link>
                        <span className="newsDate">{date}</span>
                        <p
                          className="newsExcerpt"
                          dangerouslySetInnerHTML={{
                            __html: post.excerpt.rendered,
                          }}
                        />
                      </div>
                    </div>
                  </article>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}

export default News;
